<template>
  <v-container fluid fill-height :grid-list-lg="mobile" :grid-list-xl="!mobile">
    <template v-if="applications.length > 0">
      <nav-study-program-offer-sort :sort-position="sortPosition" :total-count="applications.length" :name="candidateName" />
      <div v-if="sortPosition < applications.length && candidate !== null && !$apollo.loading" style="width:100%;">
        <secondary-posting
          v-if="secondaryProgramPosting !== null"
          :secondaryPosting="secondaryProgramPosting"
          :margin="margin"
          forcedLanguage="fr"
          :isStudyProgram="true"
        />
        <candidate-profile :user="candidate" />
        <ui-action>
          <v-tooltip top color="green">
            <template v-slot:activator="{ on }">
              <v-btn color="green" fab dark icon v-on="on" @click="sendToProspect">
                <v-icon>check</v-icon>
              </v-btn>
            </template>
            {{ $t('tinder-send-to-prospect-btn') }}
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="grey lighten-2" fab light icon v-on="on" @click="passCandidate">
                <v-icon>timer</v-icon>
              </v-btn>
            </template>
            {{ $t('tinder-pass-candidate-btn') }}
          </v-tooltip>
          <v-tooltip top color="red">
            <template v-slot:activator="{ on }">
              <v-btn color="red" fab dark icon v-on="on" @click="rejectCandidate">
                <v-icon>clear</v-icon>
              </v-btn>
            </template>
            {{ $t('tinder-reject-candidate-btn') }}
          </v-tooltip>
        </ui-action>
      </div>
      <!-- End of sort -->
      <ui-grid-middle v-else-if="!$apollo.loading">
        <ui-call-to-action>
          <template v-slot:visual>
            <ui-illustration value="profile-analyze"></ui-illustration>
          </template>
          <template v-slot:default>
            <h2 class="display-3 ma-0">{{ $t('tinder-end-sort-title') }}</h2>
            <p>{{ $t('tinder-end-sort-desc') }}</p>
          </template>
          <template v-slot:action>
            <v-btn
              v-if="studyProgramPosting.pipeline.applications.results.totalPages > page"
              color="primary"
              @click="continueSort"
              >{{ $t('tinder-end-sort-continue-btn') }}</v-btn
            >
            <v-btn color="primary" outline @click="returnToPipeline">{{ $t('tinder-end-sort-return-pipeline-btn') }}</v-btn>
          </template>
        </ui-call-to-action>
      </ui-grid-middle>
    </template>
  </v-container>
</template>
<script>
import CandidateProfile from '@/components/candidate/profile-educational'
import NavStudyProgramOfferSort from '@/components/nav/nav-job-offer-sort'
import SecondaryPosting from '@/components/candidate/profile-card/secondary-posting'

import Pipeline from '@/services/study-program-pipeline'
import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

import gql from 'graphql-tag'

const GET_NEW_APPLICATION = gql`
  query GetNewStudyProgramApplication(
    $studyProgramPostingId: ID!
    $page: Int!
    $limit: Int!
    $filters: StudyProgramApplicationFiltersInput
    $sortLanguage: ContentLanguage!
  ) {
    studyProgramPosting(id: $studyProgramPostingId) {
      id
      pipeline {
        id
        applications(page: $page, limit: $limit, filters: $filters, sortLanguage: $sortLanguage) {
          results {
            items {
              id
              candidate {
                id
                user {
                  id
                }
              }
              possibleNextSteps
              createdAt
            }
            totalPages
          }
        }
      }
    }
  }
`
const GET_CANDIDATE_PROFILE_EDUCATIONAL_BY_APPLICATION_ID = gql`
  query GetCandidateProfileById($id: ID!, $language: ContentLanguage!, $countryLanguage: CountryLanguage) {
    studyProgramApplication(id: $id) {
      id
      candidate {
        id
        user {
          id
          email
          type
        }
        languages {
          id
          language
          level
        }
        firstName
        lastName
        linkedInProfile
        picture
        phoneNumber
        cellphoneNumber
        birthdate
        educationLevel
        frenchLanguageTestPassed
        nationalities(language: $countryLanguage) {
          id
          countryCode
          name
        }
        country(language: $countryLanguage) {
          id
          countryCode
          name
        }
        currentlySubscribedToStudyProgram
        overallAverage
        lastYearAverage
        ratingSystem
        hasReportsAndDiplomasCopy
        trainingLevel
        trainingRelated
        currentStudyProgramLevel
        hasPassport
        hasTraveled
        hasTraveledToCanada
        hasCanFam
        hasVisaRefused
        hasInfraction
        hasEntryRefused
        visaRefusedType
        tuitionFeesAbleToPay
        studyExpensesPayer
        hasFirstStudyYearLivingExpensesFinancialResources
        livingExpensesPayer
        willComeToCanadaWithFamilyMember
        financialResourcesProofs
        isInterestedInPartTimeJob
        isInterestedInJobAfterGraduating
        homeCountryJobProspects
        translationOrDefault(language: $language) {
          id
          immigrationProject
          personalDescription
          personalDescriptionStudent
          visaRefusedReason
          willComeToCanadaWithFamilyMemberSpecification
          livingExpensesPayerOtherSpecification
          studyExpensesPayerOtherSpecification
          dreamJobDescription
        }
        translations {
          id
          language
          education {
            id
            details
            domain
            graduationDate
            level
            schoolName
            startDate
          }
          dreamJobDescription
        }
      }
      secondaryStudyProgramPosting {
        id
        publishedVersion {
          id
          translationOrDefault(language: $language) {
            id
            title
          }
        }
        institution {
          id
          name
        }
      }
    }
  }
`

export default {
  data() {
    return {
      page: 1,
      sortPosition: 0,
      applications: [],
      currentUser: null,
      candidate: {}
    }
  },
  components: {
    CandidateProfile,
    NavStudyProgramOfferSort,
    SecondaryPosting
  },
  computed: {
    candidateName: function() {
      if (this.currentUser === null) {
        return ''
      }

      return `${this.currentUser.firstName} ${this.currentUser.lastName}`
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    studyProgramPostingId: function() {
      return this.$route.params.studyProgramPostingId.split('-').last()
    },
    currentCandidateId: function() {
      return this.candidate.id
    },
    currentApplicationId: function() {
      return this.applications[this.sortPosition].id
    },
    margin() {
      return this.mobile ? 'mb-3' : 'mb-4'
    },
    secondaryProgramPosting: function() {
      return this.candidate.secondaryStudyProgramPosting
    }
  },
  methods: {
    sendToProspect: async function() {
      await Pipeline.setApplicationsPipelineStep([this.candidate.id], this.studyProgramPostingId, Consts.JOB_OFFER_STEP_PROSPECT)
      this.sortPosition++
    },
    passCandidate: async function() {
      this.sortPosition++
    },
    rejectCandidate: async function() {
      await Pipeline.setApplicationsPipelineStep([this.candidate.id], this.studyProgramPostingId, Consts.JOB_OFFER_STEP_REJECTED)
      this.sortPosition++
    },
    returnToPipeline: function() {
      this.$router.push(
        i18n
          .getLocalizedUrl(Consts.URL_STUDY_PROGRAM_PIPELINE)
          .replace(Consts.URL_PARAMS_STUDY_PROGRAM_ID, this.$route.params.studyProgramPostingId)
          .replace(Consts.URL_PARAMS_BUSINESS_ID, this.$route.params.businessId)
      )
    },
    continueSort: function() {
      this.applications = []
      this.sortPosition = 0
      this.$apollo.queries.studyProgramPosting.refresh()
      this.currentUser = null
    }
  },
  apollo: {
    studyProgramPosting: {
      query: GET_NEW_APPLICATION,
      variables() {
        return {
          studyProgramPostingId: this.studyProgramPostingId,
          page: 1,
          limit: Consts.CANDIDATE_NEW_APPLICATION_SORT_LIMIT_COUNT,
          filters: {
            step: Consts.JOB_OFFER_STEP_NEW
          },
          sortLanguage: this.$currentContentLanguage()
        }
      },
      result({ data, loading }) {
        if (data === undefined) {
          if (!loading) {
            //throw error
          }
          return
        }

        this.applications = data.studyProgramPosting.pipeline.applications.results.items
      }
    },
    studyProgramApplication: {
      query: GET_CANDIDATE_PROFILE_EDUCATIONAL_BY_APPLICATION_ID,
      variables() {
        return {
          id: this.currentApplicationId,
          language: this.$currentContentLanguage(),
          countryLanguage: this.$currentCountryLanguage()
        }
      },
      skip() {
        return this.applications.length === 0 || this.sortPosition >= this.applications.length
      },
      result({ data, loading }) {
        if (data === undefined) {
          if (!loading) {
            //throw error
          }
          return
        }

        this.candidate = {
          id: data.studyProgramApplication.candidate.user.id,
          email: data.studyProgramApplication.candidate.user.email,
          type: data.studyProgramApplication.candidate.user.type,
          profile: data.studyProgramApplication.candidate,
          secondaryStudyProgramPosting: data.studyProgramApplication.secondaryStudyProgramPosting
        }

        this.currentUser = data.studyProgramApplication.candidate
      }
    }
  }
}
</script>
